export const RockTheVoteDetails = {
    title: 'Rock The Vote',
    label: 'POWERED BY ROCK THE VOTE',
    description:
        'Rock the Vote is a nonpartisan nonprofit dedicated to building the political power of young people. <br /><br />' +
        'They’ve registered and turned out millions of young voters on campuses, in communities, and online. They’ve successfully fought for — and defended — voting rights and increased access to democracy. They’ve raised awareness and campaigned for issues that impact the lives of young people. <br /><br />' +
        'They’ve pioneered innovative ways to make registration and voting work for our generation, and built open-source technology to empower other organizations, too. <a href="https://www.rockthevote.org/rock-the-vote-2016-annual-report/" target="_blank">View their 2016 Impact Report</a>.'
};



// WEBPACK FOOTER //
// ./src/components/Shared/rockTheVoteDetails.js